import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing } = themeVariables;

const CONTROL_SIZE = `44px`;

export const singleItem = css`
  width: 100%;
`;

export const carousel = css`
  position: relative;
  width: 100%;
`;

export const viewport = css`
  overflow: hidden;
  position: relative;
`;

export const container = css`
  display: flex;
  /*
   * Pre-centre the first slide for the server-rendered / pre-hydration frame so it matches where
   * Embla rests it once initialised (align: 'center'). The hero is full-bleed and each slide is
   * 90vw, leaving a 10vw peek split 5vw per side, so shifting the track 5vw right centres slide 1.
   * Embla replaces this with its own inline transform on init (inline wins), so the image doesn't
   * jump on hydration; only the left-hand looped clone fills in afterwards.
   */
  transform: translate3d(7%, 0, 0);

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      transform: translate3d(0, 0, 0);
    `,
  )};
`;

export const slide = css`
  flex: 0 0 86%;
  min-width: 0;
  margin-right: var(${spacing.xxs});

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      flex: 0 0 100%;
      min-width: 0;
      margin-right: var(${spacing.xxs});
    `,
  )};
`;

export const control = css`
  position: absolute;
  top: calc(50% - ${CONTROL_SIZE});
  z-index: 1;
  background-color: var(${colors.surface.default});
  border-radius: var(${borderRadius.full.desktop});
  width: ${CONTROL_SIZE};
  height: ${CONTROL_SIZE};
  display: none;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  color: var(${colors.content.default});
  cursor: pointer;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: flex;
    `,
  )};
`;

export const controlPrevious = css`
  left: calc(${CONTROL_SIZE} + 40px);
`;

export const controlNext = css`
  right: calc(${CONTROL_SIZE} + 40px);
`;
